import { isJaguar, isSuperadmin } from "@/utility/UserUtils";
import React from "react";
import {
  Paper,
  MenuItem,
  Menu,
  MenuList,
  ListItemIcon,
  Divider
} from "@mui/material"
import SettingsIcon from '@mui/icons-material/Settings';
import LogoutIcon from '@mui/icons-material/Logout';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
const UserMenu = ({
  user
}) => {


  const getLinks = () => {
    return [
      {divider: true},
      {label: "Inventory Management", href: "/management/items", disabled: !isJaguar(user), icon: <SettingsIcon />},
      {label: "Address Book", href: "/events/shipping_addresses", disabled: !isJaguar(user), icon: <LocationOnIcon />},
      {label: "Users", href: "/management/users", disabled: !isJaguar(user), icon: <PersonIcon/>},
      {divider: true},
      {label: "Sign Out", href: "/users/sign_out", icon: <LogoutIcon />}
    ].filter(link => !link.disabled)
  }

  const renderLinks = (link) => {
    if(link.divider) {
      return <Divider style={{width:'100%'}} />
    }
    return (
       <MenuItem 
       
        component="a"
        key={link.href}
        href={link.href}
        sx={{
          "&:hover": {
            backgroundColor: "rgb(241 245 254)",
            color: "black"
          }
        }}
        >
        {link.icon && (
          <ListItemIcon>
            {link.icon}
          </ListItemIcon>
        )}
        {link.label}
      </MenuItem>
    )
  }
  
  return (
    <Paper className="absolute right-0 mt-2 z-10">
      <MenuList>
        <MenuItem
          sx={{
            "&:hover": {
              backgroundColor: "white",
              color: "black"
            }
          }}
        >
          <div className="mb-2">
            <div class="self-stretch justify-start text-text-primary/90 text-base font-normal font-['Roboto'] leading-6 tracking-tight">
              {user ? `${user.first_name} ${user.last_name}` : ""}
            </div>
            <div class="self-stretch justify-start text-text-secondary/60 text-sm font-normal font-['Roboto'] leading-5 tracking-tight">
              {user ? user.email : ""}
            </div>
          </div>
        </MenuItem>
        <div onClick={(e) => e.stopPropagation()} className="navbar-user-menu-container">
          {
            getLinks().map(link => renderLinks(link))
          }
        </div>
      </MenuList>
    </Paper>
  )
}

export default UserMenu